import { sanitizeDisplayName } from './sanitizeDisplayName';

const EMPTY_INITIALS = '';

export default function getInitial(name: string | undefined | null): string {
    const sanitizedName = sanitizeDisplayName(name);

    if (sanitizedName.length === 0) {
        return EMPTY_INITIALS;
    }

    return toTitleCaseInitials(sanitizedName);
}

// This function will return the initials of the name in title case
function toTitleCaseInitials(name: string): string {
    const splits: string[] = name.split(' ');

    let initials = splits[0].charAt(0).toUpperCase();

    if (splits.length >= 2) {
        initials += splits[splits.length - 1].charAt(0).toUpperCase();
    }
    return initials;
}
